import React from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeEvents } from "../../../api/queries/homeQueries";
import EventCard from "./EventCard";
import { UiTitle } from "../../../components/text/UiTitle";
import { useTranslationEx } from "../../../hooks/useTranslationEx";

// Sample data

interface EventwiperProps {}

const EventSwiper: React.FC<EventwiperProps> = () => {
  const { t } = useTranslation();
  const { handleSlideChange, events } = useHomeEvents();
  const { t2 } = useTranslationEx();
  return (
    <div className="flex w-full flex-col justify-center gap-4 sm:gap-10">
      <UiTitle text={t("Event")} />
      <div className="w-full">
        <div className="relative">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={24}
            centeredSlides={false}
            loop={false}
            onSlideChange={handleSlideChange}
            className="event-swiper"
          >
            {events.map((event, index) => (
              <SwiperSlide
                className="max-h-[10rem] max-w-[23.125rem]"
                key={index}
              >
                <a className="h-full w-full" href={`/events/${event.id}`}>
                  <EventCard
                    img={event.thumbnail}
                    name={t2(event.title)}
                    startDate={event.startDate}
                    endDate={event.endDate}
                  />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};
export default EventSwiper;
